import React from 'react';

const Home = () => (
  <div className="home">
    <br />
    <br />

    <h3>Welcome to our Page!</h3>
    <br />
    <br />

    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
      incididunt ut
      labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
      ullamco laboris
      nisi ut aliquip ex ea commodo consequat.
    </p>

    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
      incididunt ut
      labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
      ullamco laboris
      nisi ut aliquip ex ea commodo consequat.
    </p>
  </div>
);

export default Home;
